/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IBosonDisputeHandler,
  IBosonDisputeHandlerInterface,
} from "../IBosonDisputeHandler";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_buyerPercent",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeDecided",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "disputeResolverId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeEscalated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeExpired",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "buyerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeRaised",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_buyerPercent",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeResolved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeRetracted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newDisputeTimeout",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "DisputeTimeoutExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "EscalatedDisputeExpired",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "EscalatedDisputeRefused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "entityId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "exchangeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "FundsEncumbered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "entityId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "exchangeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "FundsReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "withdrawnTo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "FundsWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "exchangeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "ProtocolFeeCollected",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_buyerPercent",
        type: "uint256",
      },
    ],
    name: "decideDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "escalateDispute",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "expireDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_exchangeIds",
        type: "uint256[]",
      },
    ],
    name: "expireDisputeBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "expireEscalatedDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_newDisputeTimeout",
        type: "uint256",
      },
    ],
    name: "extendDisputeTimeout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "getDispute",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "exchangeId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyerPercent",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.DisputeState",
            name: "state",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.Dispute",
        name: "dispute",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "disputed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalated",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "finalized",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timeout",
            type: "uint256",
          },
        ],
        internalType: "struct BosonTypes.DisputeDates",
        name: "disputeDates",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "getDisputeState",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        internalType: "enum BosonTypes.DisputeState",
        name: "state",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "getDisputeTimeout",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "timeout",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "isDisputeFinalized",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isFinalized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "raiseDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "refuseEscalatedDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_buyerPercent",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "_sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "_sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "_sigV",
        type: "uint8",
      },
    ],
    name: "resolveDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "retractDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IBosonDisputeHandler__factory {
  static readonly abi = _abi;
  static createInterface(): IBosonDisputeHandlerInterface {
    return new utils.Interface(_abi) as IBosonDisputeHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IBosonDisputeHandler {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IBosonDisputeHandler;
  }
}
